import { TranslatePlural } from '@change-corgi/core/react/i18n';

export const SignersText: React.FC<{
	constituentCount: number;
	isFormer: boolean;
	constituentCountLocalized: string;
}> = ({ constituentCount, isFormer, constituentCountLocalized }) => {
	return isFormer ? (
		<TranslatePlural
			value="corgi.petition_gamma.decision_makers_v2.constituency_former"
			replacements={{ numberOfConstituents: constituentCountLocalized }}
			count={constituentCount}
		/>
	) : (
		<TranslatePlural
			value="corgi.petition_gamma.decision_makers_v2.constituency"
			replacements={{ numberOfConstituents: constituentCountLocalized }}
			count={constituentCount}
		/>
	);
};
